import React from "react";
import { gql } from "apollo-boost";
import { useMutation } from "@apollo/react-hooks";
import { SC_sc_workGroups } from "../../SC/__generated__/SC";
import { Table } from "antd";
import assign from "lodash.assign";
import { Button } from "antd";

const FACTORIESCHANGEWORKGROUPSTATUS = gql`
  mutation FACTORIESCHANGEWORKGROUPSTATUS(
    $sc: ID!
    $group: Int!
    $newStatus: String!
  ) {
    changeWorkGroupStatus(sc: $sc, group: $group, newStatus: $newStatus) {
      sc
    }
  }
`;

interface Props {
  sc: string;
  factories: SC_sc_workGroups[];
  reload: any;
}

export const Factories = ({ sc, factories, reload }: Props) => {
  const [changeStatus] = useMutation(FACTORIESCHANGEWORKGROUPSTATUS);

  const handleChangeStatus = async (
    sc: string,
    group: number,
    newStatus: string
  ) => {
    await changeStatus({ variables: { sc, group, newStatus } });
    reload();
    return null;
  };

  var children: JSX.Element[] = [];

  children.push(<h3 key={"Factories"}>Manufacturing Operations</h3>);

  const sorted = factories.sort((a, b) => b.group - a.group);

  function formatNumber(num: number) {
    num = Math.floor(num);
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }

  function formatWIP(amount: number, tl: number, wip: number | null) {
    const capacity = amount * 60 * tl;
    return wip ? ((wip / capacity) * 100.0).toFixed(0) + "%" : "0%";
  }

  function formatItem(item: string | null, tl: number | null) {
    return tl ? item + "-" + tl : item;
  }

  const factoryColumns = [
    {
      title: <p style={{ textAlign: "center" }}>Number of Factories</p>,
      dataIndex: "number",
      key: "factoryNumber",
      render: (text: any) => <p style={{ textAlign: "center" }}>{text}</p>,
    },
    {
      title: <p style={{ textAlign: "center" }}>TL</p>,
      dataIndex: "tl",
      key: "factoryTL",
      render: (text: any) => <p style={{ textAlign: "center" }}>{text}</p>,
    },
    {
      title: <p style={{ textAlign: "center" }}>Output</p>,
      dataIndex: "output",
      key: "outputItem",
      render: (text: any) => <p style={{ textAlign: "center" }}>{text}</p>,
    },
    {
      title: <p style={{ textAlign: "center" }}>Work in Progress</p>,
      dataIndex: "wip",
      key: "wip",
      render: (text: any) => <p style={{ textAlign: "center" }}>{text}</p>,
    },
    {
      title: <p style={{ textAlign: "center" }}>Status</p>,
      dataIndex: "status",
      key: "factoryStatus",
      render: (value: any) => (
        <Button
          block
          onClick={() => handleChangeStatus(sc, value.group, value.nextStatus)}
        >
          {value.status}
        </Button>
      ),
    },
  ];

  let factoryData: any = [];

  sorted.forEach((q) => {
    const wip = formatWIP(q.amount, q.tl, q.wip);

    const nextStatus =
      q.status === "Running"
        ? "Shut Down"
        : q.status === "Retire Hold"
        ? "Retirement"
        : q.status === "Shut Down"
        ? wip === "100%"
          ? "Retirement"
          : "Running"
        : wip === "100%"
        ? "Running"
        : "Retire Hold";

    factoryData.push(
      assign({
        key: q.group,
        number: formatNumber(q.amount),
        tl: q.tl,
        output: formatItem(q.outputItem, q.outputTL),
        wip: wip,
        status: { status: q.status, group: q.group, nextStatus: nextStatus },
      })
    );
  });

  children.push(
    <Table
      key="FactoryTable"
      size="middle"
      dataSource={factoryData}
      columns={factoryColumns}
    />
  );

  return <div>{children}</div>;
};
